// extracted by mini-css-extract-plugin
export default {"button":"CpufPsZNo4EV0lCY_Ylg","profileInitials":"Ven7f7eImJAVO07pU40M"};